import { AxiosResponse } from 'axios';
import { Actions } from 'vuex-smart-module';
import { ClientsService } from '../../../services';
import { Clients } from '../../../types';
import ClientDetailGetters from './getters';
import ClientDetailMutations from './mutations';
import ClientDetailState from './state';

const clientsService = new ClientsService();

export default class ClientDetailActions extends Actions<
  ClientDetailState,
  ClientDetailGetters,
  ClientDetailMutations,
  ClientDetailActions
> {
  async get_client_by_id(id: string | number) {
    try {
      const { data } = await clientsService.get_client_by_id(id);

      this.mutations.SET_CURRENT_CLIENT(data);
    } catch (error) {
      console.error(error);
      return (error as AxiosResponse).status;
    }
  }

  async update_client(client: Clients.Client) {
    try {
      const data = await clientsService.update_client(client);

      this.mutations.SET_CURRENT_CLIENT(client);

      return data;
    } catch (error) {
      console.error(error);
      return (error as AxiosResponse).data;
    }
  }
}
